import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DscAcceptanceError, DscAcceptanceParams, DscParams } from './compliance-adapter.models';

import { DscAcceptancePayload, DscPayload } from '@api/_api/api-compliance-adapter/api-compliance-adapter.models';
import { ApiComplianceAdapterService } from '@api/_api/api-compliance-adapter/api-compliance-adapter.service';

@Injectable()
export class ComplianceAdapterService {
    constructor(
        private readonly apiDscService: ApiComplianceAdapterService
    ) { }

    public createDistanceSaleContract(dscParams: DscParams): Observable<string> {
        const payload: DscPayload = {
            payments: dscParams.payments,
            customerId: dscParams.customerId,
            // biome-ignore lint/style/useNumberNamespace: <explanation>
            storeId: parseInt(dscParams.storeId),
            locale: dscParams.locale,
            device: {
                os: 'os',
                channel: [
                    'web-standard',
                ],
                type: 'desktop',
                brand: 'md',
            },
        };

        return this.apiDscService.createDistanceSaleContract(payload, dscParams.languageId).pipe(
            map((response) => {
                return atob(response.content);
            })
        );
    }

    public acceptDistanceSaleContract(dscAcceptanceParams: DscAcceptanceParams): Observable<any> {
        return this.apiDscService.acceptDistanceSaleContract(
            dscAcceptanceParams as unknown as DscAcceptancePayload,
            dscAcceptanceParams.languageId
        ).pipe(
            map((success) => {
                if (!success) {
                    throw new DscAcceptanceError('Unable to accept the Distance Sale Contract');
                }

                return true;
            })
        );
    }
}
